export default __webpack_public_path__ + "static/media/closet5-before2-1024w.a8bc192f.png";